import { render } from "./BlogCategoriesTravel.vue?vue&type=template&id=062be63a&scoped=true"
import script from "./BlogCategoriesTravel.vue?vue&type=script&lang=js"
export * from "./BlogCategoriesTravel.vue?vue&type=script&lang=js"

import "./BlogCategoriesTravel.vue?vue&type=style&index=0&id=062be63a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-062be63a"

export default script